<template>
  <div class="backgroundAutorizaciones" id="background6">
    <div class="transbox" id="transbox6"> 
      <h1 class="pulse">Autorizaciones</h1>
      <br>
      <ul>
        <li>AAI - Gestor de residuos PELIGROSOS - 07G01112400000046</li>
        <li>AAI - Gestor de residuos NO PELIGROSOS - 07G04012400000046</li>
        <li>Transporte de residuos PELIGROSOS - 07T01102400000046</li>
        <li>Transporte de residuos NO PELIGROSOS - 07T02102400000046</li>
        <li>Negociante de residuos PELIGROSOS -  07N01142400000046</li>
        <li>Negociante de residuos NO PELIGROSOS -  07N02142400000046</li>
        <li>Agente de residuos PELIGROSOS -  07A01142400000046</li>
        <li>Agente de residuos NO PELIGROSOS -  07A02142400000046</li>
        <br>
        <li>Reutilización y subproductos</li>
        <li>Registro REA - 08/24/0024977</li>
        <li>Registro RERA (AMIANTO)</li>
        <li>Registro transporte SANDACH - TS ES 08 24 0000021</li>
        <li>Transporte de Mercancias PELIGROSAS</li>
        <li>Transporte de MATERIAS PRIMAS</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Autorizaciones',
  props: {
    msg: String
  },
  created(){
    window.addEventListener("scroll", function () {
      if (document.querySelector("#background6").getBoundingClientRect().top < this.window.innerHeight){
        document.querySelector("#transbox6").classList.add("animation")
      } 
    })
  }
}
</script>

<style scoped>
h3 {
  margin: 40px 0 0;
}
li{
  margin: 0 40px 0;
}
a {
  color: #42b983;
}

div.backgroundAutorizaciones {
  padding-left: 5%;
  padding-right: 5%;
  padding-top: 5px;
  padding-bottom: 5px;
  min-width: 800px;
}
@font-face {
font-family: geomanist;
src: url("../assets/geomanist-regular-webfont.ttf");
}
div.transbox {
  margin: 30px;
  padding : 5%;
  font-family: Arial, Helvetica, sans-serif;
  text-align: justify;
  background: linear-gradient(300deg, rgb(27, 94, 32, 0.8) 0%, rgba(144,238,144,0.8) 50%, rgb(255, 255, 255, 0.8) 100%);
  box-shadow: 10px 10px 5px 0px rgba(0,0,0,0.75);
  border-radius: 15px;
  min-width: 750px;
}

div {
  font-size: 30px;
}

.animation{
  animation-name: opacity1;
  animation-duration: 1000ms;
  transform-origin:70% 70%;
  animation-iteration-count: initial;
  animation-timing-function: linear;
}

@keyframes opacity1 {
  0% {
        display: none;
        opacity: 0;
    }

    1% {
        display: block;
        opacity: 0;
    }

    100% {
        display: block;
        opacity: 0.8;
    }
}
.pulse:hover {
    animation-name: pulse_animation1;
    animation-duration: 5000ms;
    transform-origin:0% 70%;
    animation-iteration-count: infinite;
    animation-timing-function: linear;
}

@keyframes pulse_animation1 {
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}
</style>